const ArrowRightIcon = ({ inverse = false }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.419 13.349a1.035 1.035 0 0 1-.001-1.518L10.467 9H3.6a1 1 0 1 1 0-2h6.867L7.417 4.17a1.035 1.035 0 0 1 1.408-1.518l4.983 4.615a1 1 0 0 1 0 1.467l-4.983 4.615a1.035 1.035 0 0 1-1.406 0z"
        className={inverse ? "icon-fill-primary" : "icon-fill-primary-inverse"}
      />
    </svg>
  );
};

export default ArrowRightIcon;
